import React, { useCallback, useMemo, useState,useEffect } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import notiifcationicon from '../../assets/images/admin/navbar/notifcation.svg';
import userimg from '../../assets/images/admin/navbar/user.png';
import dropdown from '../../assets/images/admin/navbar/dropdown.svg';
import { useNavigate } from "react-router-dom";
import notificationrowicon from '../../assets/images/admin/navbar/notificationrowicon.svg';
import { apiUrl } from "../../config/Config";
import axios from "axios";
import { useDispatch, useSelector } from 'react-redux';
import { formatIstDateTime } from "../../utils/dateTime";

const Navbar = (props) => {
    const [shownavdropdown, setshownavdropdown] = useState(false);
    const [open, setOpen] = useState(false);
    const [reportNotifications, setReportNotifications] = useState([]);
    const [notificationsLoading, setNotificationsLoading] = useState(false);

    const userdata = useSelector((store) => store.userReducer.userdata);


    let navigate = useNavigate();
    const dispatch = useDispatch();

    const headers = useMemo(() => ({
      headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer " + userdata?.token,
      }
    }), [userdata?.token]);

    // console.log('userdata >>', userdata);

    const handleInvalidUser = useCallback((message) => {
      if (message === "invalid user") {
        dispatch({ type: "userdata", payload: {} });
        navigate("/admin/login");
        return true;
      }
      return false;
    }, [dispatch, navigate]);

    const fetchReportNotifications = useCallback(async () => {
      if (!userdata?.token) {
        return;
      }

      setNotificationsLoading(true);
      await axios
        .get(apiUrl + "admingetcontentreports?status=pending&limit=6", headers)
        .then((res) => {
          if (res.data.status === "success") {
            setReportNotifications(res.data.data || []);
          } else if (!handleInvalidUser(res.data.message)) {
            setReportNotifications([]);
          }
        })
        .catch(() => {
          setReportNotifications([]);
        });
      setNotificationsLoading(false);
    }, [handleInvalidUser, headers, userdata?.token]);

    const openReportQueue = () => {
      setOpen(false);
      navigate("/admin/moderation?tab=reports");
    };

    const handlelogout = async() => {
      // console.log('handlelogout');
      // dispatch({ type: "userdata", payload: {} })
      var data = {
        
    }
    await axios.post(apiUrl + 'adminlogout', data, headers).then((res) => {
        if(res.data.status === 'success') {
          dispatch({ type: "userdata", payload: {} })
        navigate('/admin/login');
        } else {
          if(res.data.message === "invalid user") {
            dispatch({ type: "userdata", payload: {} })
            navigate('/admin/login');
          } else {
            alert(res.data.message);
          }
          
        }
    } ).catch((err) => {
        alert(err.message)
    })
    }

    useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
          fetchReportNotifications();
        } else {
          navigate("/admin/login");
        }
      }, [fetchReportNotifications, navigate, userdata]);


    return (
      <>
        <div className="navbarmaindiv">
          <div className="navbarrow">
            <p className="nav-pagetitle">{props.title}</p>
            {/* <div className="nav-searchdiv">
              <input
                type="text"
                className="form-control nav-searchinput"
                placeholder="Search here..."
              />
              <img src={searchicon} className="nav-searchicon" />
            </div> */}
            <div
              className="notificationbg"
              style={{ cursor: "pointer", marginLeft: 'auto' }}
              onClick={() => {
                const nextOpen = !open;
                setOpen(nextOpen);
                if (nextOpen) {
                  fetchReportNotifications();
                }
              }}
            >
              <img src={notiifcationicon} className="nav-notifyicon" alt="" />
              {reportNotifications.length > 0 ? (
                <span className="admin-notification-badge">{reportNotifications.length}</span>
              ) : null}
            </div>
            {open ? (
              <div className="admin-notification-dropdown">
                <div className="admin-notification-dropdown-header">
                  <div>
                    <p>Reports</p>
                    <span>{reportNotifications.length} pending content reports</span>
                  </div>
                  <button onClick={openReportQueue}>View all</button>
                </div>
                <div className="admin-notification-dropdown-list">
                  {notificationsLoading ? (
                    <p className="admin-notification-empty">Loading reports...</p>
                  ) : null}
                  {!notificationsLoading && reportNotifications.length === 0 ? (
                    <p className="admin-notification-empty">No pending reports</p>
                  ) : null}
                  {!notificationsLoading && reportNotifications.map((report) => (
                    <button className="admin-notification-item" key={report.id} onClick={openReportQueue}>
                      <span className="notification-rowimgdiv">
                        <img src={notificationrowicon} className="notification-rowimg" alt="" />
                        <span className="newnotiifcationcircle"></span>
                      </span>
                      <span className="admin-notification-copy">
                        <strong>{report.reporter_name || "User"} reported a post</strong>
                        <small>{report.reason || report.post_text || "Needs admin review"}</small>
                      </span>
                      <time>{formatIstDateTime(report.created_at)}</time>
                    </button>
                  ))}
                </div>
              </div>
            ) : null}
            <div
              className="nav-profilediv"
              onClick={() => {
                setshownavdropdown(!shownavdropdown);
              }}
            >
              <img src={userimg} className="nav-userimg" alt="" />
              <div className="nav-profilenamediv">
                <p className="nav-profilename">{userdata?.firstname} {userdata?.lastname}</p>
                <p className="nav-profiledesig">{userdata?.type}</p>
              </div>
              <div className="nav-profiledowndiv">
                <img src={dropdown} className="nav-profiledownicon" alt="" />
              </div>
              {shownavdropdown ? (
                <div className="dropdown-content" style={{ display: "block" }}>
                  {/* <div
                    onClick={() => {navigate('/admin/profile')}}
                    className={"sidebarnavrow navbardropdownicon atag"}
                  >
                    <div className="navbarnavicon" />
                    <p className="shoppingtext">Profile</p>
                  </div> */}
                  <div
                    onClick={() => {handlelogout()}}
                    className={"sidebarnavrow navbardropdownicon atag"}
                  >
                    {/* <img src={sidebar_signout} className="sidebarnavicon" /> */}
                    <div className="navbarnavicon navbarnavicon1" />
                    <p className="shoppingtext">Sign Out</p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
}

export default Navbar
